export default __webpack_public_path__ + "static/media/bg-halopagi-1.65aecec3.png";